/**
 * Ciste funkce pro nabizene hodnoty dojezdu do zbrojnice.
 *
 * Zamerne ve vlastnim modulu, ne v JednotkaTab.tsx: ten pres MapPickerDialog stahne
 * react-leaflet (ESM), ktery Jest v tomto repu neprelozi, takze by logika nesla
 * otestovat bez rozsahle konfigurace transformu.
 */

/** Stejna pravidla jako serverova validace v JednotkaService.serializujPresety. */
export function jsouPresetyPlatne(cisla: number[]): boolean {
    if (cisla.length !== 3) return false;
    if (!cisla.every((n) => Number.isFinite(n) && n >= 1 && n <= 60)) return false;
    return cisla[0] < cisla[1] && cisla[1] < cisla[2];
}

/**
 * Slozi DTO k ulozeni z nactene jednotky a tri textovych poli formulare.
 *
 * Kdyz hodnoty nejsou platne, vrati PUVODNI — formular uklada cele DTO naraz, takze
 * poloprazdna nebo neserazena trojice by pri ulozeni jine zmeny (treba telefonu)
 * jednotce prepsala nastaveni na nesmysl nebo NaN. Atributy min/max na HTML inputu
 * programovemu zapisu nezabrani.
 */
export function pripravJednotkuKUlozeni<T extends { dojezdPresety?: number[] }>(
    jednotka: T,
    poleDojezd: string[],
): T {
    const cisla = poleDojezd.map((v) => Number.parseInt(v, 10));
    return { ...jednotka, dojezdPresety: jsouPresetyPlatne(cisla) ? cisla : jednotka.dojezdPresety };
}
